import { environment } from '@environments/environment';

export class LoggingLevel {
  public static None = 'None';
  public static Verbose = 'Verbose';
  public static Info = 'Info';
  public static Warnings = 'Warnings';
  public static Errors = 'Errors';
  public static All = 'All';
}

export class Logger {
  private _level: LoggingLevel = environment.production ? LoggingLevel.None : LoggingLevel.Verbose;

  error(...messages: any | any[]) {
    this.printLog(LoggingLevel.Errors, ...messages);
  }

  warn(...messages: any | any[]) {
    this.printLog(LoggingLevel.Warnings, ...messages);
  }

  info(...messages: any | any[]) {
    this.printLog(LoggingLevel.Info, ...messages);
  }

  log(...messages: any | any[]) {
    this.printLog(LoggingLevel.All, ...messages);
  }

  private printLog(level = LoggingLevel.All, ...messages: any | any[]) {
    if (!this.shouldLog(level)) {
      return;
    }

    switch (level) {
      case LoggingLevel.Errors:
        console.error(...messages);
        break;
      case LoggingLevel.Warnings:
        console.warn(...messages);
        break;
      case LoggingLevel.Info:
        // eslint-disable-next-line no-console
        console.info(...messages);
        break;
      default:
        console.log(...messages);
    }
  }

  private shouldLog(level: LoggingLevel) {
    switch (this._level) {
      case LoggingLevel.None:
        return false;
      case LoggingLevel.Errors:
        return level === LoggingLevel.Errors;
      case LoggingLevel.Warnings:
        return level === LoggingLevel.Errors || level === LoggingLevel.Warnings;
      case LoggingLevel.Info:
        return (
          level === LoggingLevel.Errors ||
          level === LoggingLevel.Warnings ||
          level === LoggingLevel.Info ||
          level === LoggingLevel.All
        );
      default:
        return true;
    }
  }
}

export const logger = new Logger();
